<script setup lang="ts">
  defineProps<{ checked: boolean }>()
  defineEmits<{ (event: 'change'): void }>()
</script>

<template>
  <label class="checkbox__wrapper bg-juss-black bg-opacity-10" tabindex="0" @keyup.enter.space="$emit('change')">
    <input class="checkbox" type="checkbox" :checked="checked" @change="$emit('change')" />
    <span class="checkbox__animated"></span>
  </label>
</template>

<style lang="sass">
  .checkbox__wrapper
    position: relative
    display: flex
    justify-content: space-between
    align-items: center
    font-size: .75em
    transition: color 150ms cubic-bezier(.4,.0,.23,1)
    input.checkbox
      height: 0
      width: 0
      visibility: hidden
      z-index: -1
      position: absolute
      top: -9999px
      left: -9999px
    span.checkbox__label
      font-weight: 600
      font-size: 1.1em
      color: theme('colors.slate.400')
      transition: 150ms ease-in-out
    span.checkbox__animated
      display: flex
      justify-content: center
      align-items: center
      width: 1.5em
      height: 1.5em
      background: white
      border: 2px solid theme('colors.slate.300')
      border-radius: 3px
      cursor: pointer
      transition: all 150ms cubic-bezier(.4,.0,.23,1)

  .checkbox__wrapper:hover
    span.checkbox__label
      color: theme('colors.slate.500')
    span.checkbox__animated
      background-color: rgb(7 59 76 / 0.1)

  input.checkbox:focus
    ~ span.checkbox__label
      color: theme('colors.slate.500')
    ~ span.checkbox__animated
      background-color: rgb(7 59 76 / 0.1)

  input.checkbox:checked
    ~ span.checkbox__label
      color: theme('colors.slate.700')
    ~ span.checkbox__animated
      position: relative
      border: .75em solid theme('colors.juss.yellow')
      animation: shrink-bounce 120ms cubic-bezier(.4,.0,.23,1)
      &:before
        content: ''
        position: absolute
        top: -0.25em
        left: -0.4em
        border-right: 3px solid transparent
        border-bottom: 3px solid transparent
        transform: rotate(45deg)
        transform-origin: 0% 100%
        animation: checkbox-check 75ms 150ms cubic-bezier(.4,.0,.23,1) forwards

  @keyframes shrink-bounce
    0%
      transform: scale(1)
    33%
      transform: scale(.85)
    100%
      transform: scale(1)

  @keyframes checkbox-check
    0%
      width: 0
      height: 0
      border-color: theme('colors.juss.black')
      transform: translate3d(0,0,0) rotate(45deg)
    33%
      width: .5em
      height: 0
      transform: translate3d(0,0,0) rotate(45deg)
    100%
      width: .5em
      height: .8em
      border-color: theme('colors.juss.black')
      transform: translate3d(0,-.5em,0) rotate(45deg)
</style>
